import storage from '@/services/storage';

const AUTH_TOKEN_KEY = 'auth-token';

export function setToken(token) {
  storage.write(AUTH_TOKEN_KEY, token);
}
export function getToken() {
  return storage.read(AUTH_TOKEN_KEY);
}
export function removeToken() {
  storage.remove(AUTH_TOKEN_KEY);
}
